// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-foot > span[data-v-222467b4] {\n  color: var(--bluey-grey);\n}\n", ""]);
// Exports
module.exports = exports;
